import React from "react";
import { Link } from "react-router-dom";
import { useSection } from "@/contexts/SiteContentContext";
import { APP_VERSION } from "@/config/beta";

export default function Footer() {
  const c = useSection("footer");
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center mb-4">
            <img src="/cbr-logo.png" alt="CBR Prospects — Canadian Baseball Rankings" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            {c.description || "The official player development, evaluation, ranking, and recruiting platform for Canadian amateur baseball. Identifying and promoting the next generation of Canadian talent."}
          </p>
        </div>

        <div>
          <h4 className="label-overline text-white/60 mb-4">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/camps" className="hover:text-[#E63946]">Camps & Events</Link></li>
            <li><Link to="/prospects" className="hover:text-[#E63946]">Prospects Database</Link></li>
            <li><Link to="/rankings" className="hover:text-[#E63946]">Rankings</Link></li>
            <li><Link to="/leaderboards" className="hover:text-[#E63946]">Leaderboards</Link></li>
            <li><Link to="/commitments" className="hover:text-[#E63946]">Commitments</Link></li>
            <li><Link to="/awards" className="hover:text-[#E63946]">Awards</Link></li>
            <li><Link to="/news" className="hover:text-[#E63946]">News</Link></li>
            <li><Link to="/media-wall" className="hover:text-[#E63946]">Media Wall</Link></li>
            <li><Link to="/sponsors" className="hover:text-[#E63946]">Sponsors</Link></li>
            <li><Link to="/about" className="hover:text-[#E63946]">About CBR</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="label-overline text-white/60 mb-4">Account</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-[#E63946]">Sign In</Link></li>
            <li><Link to="/signup" className="hover:text-[#E63946]">Create Account</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#E63946]">Parent Dashboard</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Canadian Baseball Rankings — CBR Prospects. All rights reserved.</p>
          <p className="flex items-center gap-3">
            <span>{c.tagline || "Built for serious player evaluation."}</span>
            <span data-testid="app-version" className="inline-flex items-center gap-1 text-white/40">
              <span className="w-1 h-1 rounded-full bg-[#E63946]" />
              Beta v{APP_VERSION}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
